import { defineColumn } from '../../../components/tanstack-table/column';
import { TanStackTable } from '../../../components/tanstack-table/table';
import type { ProductOrderMatch } from '../../../data/receiving';
import { emDashIfEmpty, productHeadColumns, productTailColumns } from './product-columns';

// Backend discriminant for matches produced by the suggested-item-code
// heuristic. Rows with this value go to the Speculative table and get the
// amber highlight on their Item code cell.
const SPECULATIVE_MATCH_METHOD = 'suggested_item_code';

const matchProduct = (m: ProductOrderMatch) => m.product;

const SPECULATIVE_COLUMNS = [
  ...productHeadColumns<ProductOrderMatch>(matchProduct),
  defineColumn<ProductOrderMatch>({
    id: 'Item code',
    minWidth: 100,
    maxWidth: 160,
    accessorFn: (m) =>
      emDashIfEmpty(
        m.product.item_code || m.product.suggested_item_code || m.product.raw_item_code
      ),
    cell: ({ item: m, value }) => (
      <span
        className={`font-mono ${m.matched_by === SPECULATIVE_MATCH_METHOD ? 'bg-amber-100 px-1' : ''}`}
      >
        {value}
      </span>
    ),
  }),
  defineColumn<ProductOrderMatch>({
    id: 'Matched by',
    minWidth: 140,
    maxWidth: 200,
    accessorFn: (m) => m.matched_by,
    cell: ({ value }) => <span className="text-xs text-gray-500">{value}</span>,
  }),
  ...productTailColumns<ProductOrderMatch>(matchProduct),
];

export function SpeculativeMatchesTable({ rows }: { rows: ProductOrderMatch[] }) {
  return <TanStackTable data={rows} columns={SPECULATIVE_COLUMNS} />;
}
